/**
 * Cross-component signal that the user's portfolios changed (one was created, renamed or deleted) so
 * the header re-fetches the list the Portfolio page, sidebar and switcher read. The header listens
 * for {@link PORTFOLIOS_CHANGED_EVENT}; mutators call {@link notifyPortfoliosChanged} after a
 * successful save. Same pattern as utils/gamesChanged.js.
 */
export const PORTFOLIOS_CHANGED_EVENT = 'gp-portfolios-changed';

/** Fire-and-forget: tell mounted listeners (the header) to refresh the portfolio list. */
export function notifyPortfoliosChanged() {
    if (typeof window !== 'undefined') {
        window.dispatchEvent(new Event(PORTFOLIOS_CHANGED_EVENT));
    }
}
